export default{
    actions:{
        setheadname(context,value){

        },

    },
    mutations:{
        SETHEADNAME(state,value){
            localStorage.setItem("headName",value)
            state.name =  localStorage.getItem("headName")
        },
        SETCHECK(state,value){
            localStorage.setItem("check",value)
            state.check = localStorage.getItem("check")
        },
        SETSKCD(state,value){
            localStorage.setItem("skCd",value)
            state.skCd = localStorage.getItem("skCd")
        },

        SETSKNAME(state,value){
            localStorage.setItem("skName",value)
            state.skName = localStorage.getItem("skName")
            //console.log("11111", localStorage.getItem("skName"))
        },
        SETSECONDCHECK(state,value){
            localStorage.setItem("secondcheck",value)
            state.secondcheck = localStorage.getItem("secondcheck")
        },
        //重置数据
        RESET(state,value){
            state.name = localStorage.getItem("headName") ? localStorage.getItem("headName") :"实时监控"
            state.check = localStorage.getItem("check") ? localStorage.getItem("check") : 0
            state.secondcheck = localStorage.getItem("secondcheck") ? localStorage.getItem("secondcheck") : 0
        },
        //监听侧边栏展开收拢状态
        WATCHER(state,value){
            state.isCollapse = value
        }
    },
    state:{
        name:"实时监控",
        check:0,
        secondcheck:0,
        isCollapse:true,
        skCd:'',
        skName:'',
    },
}